import { render, staticRenderFns } from "./OrderCancelForm.vue?vue&type=template&id=16af0da1"
import script from "./OrderCancelForm.vue?vue&type=script&lang=js"
export * from "./OrderCancelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports